import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/esm/Modal";
import { useTranslation } from "react-i18next";

interface LogoutModalProps {
    show: boolean;
    handleClose: () => void;
    handleLogout: () => void;
}

export default function LogoutModal({ show, handleClose, handleLogout }: LogoutModalProps) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t('auth.confirmLogout')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{t('auth.confirmLogoutMessage')}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('common.cancel')}
                </Button>
                <Button variant="outline-danger" onClick={handleLogout}>
                    {t('common.logout')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
